// Alert.alert for the web. Calls are queued here and drawn by <WebAlertHost />
// (alert.js). Kept free of other imports: web/shims/react-native.js loads it,
// and anything importing 'react-native' here would be a circular import.
const pending = [];
const listeners = new Set();

const Alert = {
  alert(title, message, buttons, options) {
    const alert = {
      title,
      message,
      buttons: buttons?.length ? buttons : [{text: 'OK'}],
      cancelable: options?.cancelable,
      onDismiss: options?.onDismiss,
    };
    if (listeners.size) {
      listeners.forEach(fn => fn(alert));
    } else {
      pending.push(alert);
    }
  },
  prompt(title, message, callbackOrButtons) {
    // eslint-disable-next-line no-alert -- the browser's own prompt is the closest match
    const value = window.prompt([title, message].filter(Boolean).join('\n\n'));
    if (value === null) {
      return;
    }
    if (typeof callbackOrButtons === 'function') {
      callbackOrButtons(value);
    } else {
      callbackOrButtons?.find(b => b.style !== 'cancel')?.onPress?.(value);
    }
  },
};

export const subscribe = fn => {
  listeners.add(fn);
  pending.splice(0).forEach(fn);
  return () => listeners.delete(fn);
};

export default Alert;
